import FormLabelInput from "../labels/form.label.input";

const DEFAULT_CLASSNAMES = {
  container: "w-full",
  select:
    "w-full text-secondary shadow focus:shadow-primary px-4 py-2 font-ubuntuMedium rounded flex justify-end focus:outline-none",
};

const FormSelectionInput = ({
  options,
  classNames = DEFAULT_CLASSNAMES,
  ...otherProps
}) => {
  return (
    <div className={`${classNames?.container || DEFAULT_CLASSNAMES.container}`}>
      <FormLabelInput>
        {otherProps.label}:
        {otherProps?.required && <span className="text-red-700 ml-1">*</span>}
      </FormLabelInput>
      <select
        {...otherProps}
        className={`${classNames?.select || DEFAULT_CLASSNAMES.select}`}
      >
        <option disabled={true} value="" className="hidden"></option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FormSelectionInput;
